module.exports = __webpack_public_path__ + "static/media/stamp_6.2d74e470.png";